import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LayoutDashboardIcon, MessageSquareIcon, MessagesSquareIcon, BoxesIcon, PuzzleIcon, BookOpenIcon, BotIcon, ListTodoIcon, HistoryIcon, SettingsIcon, XIcon, CpuIcon } from 'lucide-react';
import { useUiStore } from '../../stores/uiStore';
const nav = [{
  to: '/',
  label: '仪表盘',
  en: 'Dashboard',
  icon: LayoutDashboardIcon,
  end: true
}, {
  to: '/chat',
  label: '对话',
  en: 'Chat',
  icon: MessageSquareIcon
}, {
  to: '/models',
  label: '模型中心',
  en: 'Models',
  icon: BoxesIcon
}, {
  to: '/skills',
  label: 'Skills 中心',
  en: 'Skills',
  icon: PuzzleIcon
}, {
  to: '/knowledge-bases',
  label: '知识库中心',
  en: 'Knowledge',
  icon: BookOpenIcon
}, {
  to: '/agents',
  label: 'Agent 中心',
  en: 'Agents',
  icon: BotIcon
}, {
  to: '/tasks',
  label: '任务面板',
  en: 'Tasks',
  icon: ListTodoIcon
}, {
  to: '/history-sessions',
  label: '历史会话',
  en: 'Sessions',
  icon: MessagesSquareIcon
}, {
  to: '/history',
  label: '历史记录',
  en: 'History',
  icon: HistoryIcon
}, {
  to: '/settings',
  label: '系统设置',
  en: 'Settings',
  icon: SettingsIcon
}];
export function Sidebar() {
  const sidebarOpen = useUiStore(s => s.sidebarOpen);
  const setSidebarOpen = useUiStore(s => s.setSidebarOpen);
  const content = <div className="flex h-full flex-col" data-id="element-239">
      <div className="flex items-center gap-2.5 px-5 py-5" data-id="element-240">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-indigo-600" data-id="element-241">
          <img src="https://gm-web-1300870289.cos.ap-guangzhou.tencentcos.cn/yanqu-site/icons/logo/1780710281526_ac6bc402.png" data-id="element-242" />
        </div>
        <div data-id="element-243">
          <div className="text-sm font-semibold text-slate-100" data-id="element-244">
            研趣agent中台系统
          </div>
          <div className="text-xs text-slate-500" data-id="element-245">Yanqu Agent Console</div>
        </div>
        <button className="ml-auto rounded-lg p-1 text-slate-400 hover:bg-slate-800 lg:hidden" onClick={() => setSidebarOpen(false)} aria-label="关闭菜单" data-id="element-246">
          <XIcon className="h-5 w-5" data-id="element-247" />
        </button>
      </div>
      <nav className="flex-1 space-y-1 px-3 py-2" aria-label="主导航" data-id="element-248">
        {nav.map(item => {
        const Icon = item.icon;
        return <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setSidebarOpen(false)} className={({
          isActive
        }) => `group flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${isActive ? 'bg-indigo-600/15 text-indigo-300' : 'text-slate-400 hover:bg-slate-800/60 hover:text-slate-200'}`} data-id="element-249">
              <Icon className="h-[18px] w-[18px]" data-id="element-250" />
              <span data-id="element-251">{item.label}</span>
            </NavLink>;
      })}
      </nav>
      <div className="border-t border-slate-800 px-5 py-4 text-xs text-slate-600" data-id="element-252">
        v0.1.0 · MVP
      </div>
    </div>;
  return <>
      {/* Desktop */}
      <aside className="hidden w-60 shrink-0 border-r border-slate-800 bg-slate-900/70 lg:block" data-id="element-253">
        {content}
      </aside>

      {/* Mobile drawer */}
      {sidebarOpen && <div className="fixed inset-0 z-40 lg:hidden" data-id="element-254">
          <motion.div className="absolute inset-0 bg-black/60" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} onClick={() => setSidebarOpen(false)} data-id="element-255" />
          <motion.aside className="absolute left-0 top-0 h-full w-64 border-r border-slate-800 bg-slate-900" initial={{
        x: -280
      }} animate={{
        x: 0
      }} exit={{
        x: -280
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 35
      }} data-id="element-256">
            {content}
          </motion.aside>
        </div>}
    </>;
}